import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HoardinglistComponent } from './hoardinglist/hoardinglist.component';
import { ModifyhoardingComponent } from './modifyhoarding/modifyhoarding.component';
import { NgbPaginationModule, NgbAlertModule} from '@ng-bootstrap/ng-bootstrap';
import {​​​​​​​​ MatDatepickerModule }​​​​​​​​ from'@angular/material/datepicker';
import {​​​​​​​​ MatInputModule }​​​​​​​​ from'@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { ConfirmDialogModule } from '@app/module/confirm-dialog/confirm-dialog.module';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
// import { AgmCoreModule } from '@agm/core';


@NgModule({
  declarations: [HoardinglistComponent, ModifyhoardingComponent],
  imports: [
    CommonModule,NgMultiSelectDropDownModule.forRoot(),
    NgbPaginationModule,FormsModule,ReactiveFormsModule,Ng2SearchPipeModule,
    NgbAlertModule,MatDatepickerModule,MatInputModule,MatNativeDateModule,ConfirmDialogModule
    // AgmCoreModule.forRoot({
    //   apiKey: 'AIzaSyCraNVnfBrqtSGxkEqB0IIFCMDisxeS4r0',
    //   libraries: ['geometry', 'places']
    // })
  ]
})
export class HoardinglistModule { }
